// extracted by mini-css-extract-plugin
module.exports = {"bg":"Layout_bg__2DiHc","circle1":"Layout_circle1__2bvZP","circle2":"Layout_circle2__1FSW9","root":"Layout_root__1bq78","main":"Layout_main__1dFZc"};